export default "__VITE_ASSET__vGNYs6iS__"